import { ZTooltip } from "@/shared/components/ZTooltip/ZTooltip";
import { Button } from "@nextui-org/react";
import { ArrowLeft, Clock7, SquarePen } from "lucide-react";
import UseAskAiSocketEvents from "../hooks/useAskAiEvents";
import { useChatStore } from "../states";

export default function ChatHeader() {
  const btnClassName = "border-blue-500 text-blue-500 bg-transparent hover:bg-blue-50 w-6 h-6 min-w-0 border-[1px] ";
  const { isOpen, isShowHistory, isGenerating, setIsOpen, setMessage, setSelectedSession, setFileUploadError, setIsGenerating, setUploadedFiles, setThreadId, setMessages, setIsShowHistory } = useChatStore();

  const { cancelGeneration } = UseAskAiSocketEvents();

  // Reset all states when new chat is initiated
  const handleNewChat = () => {
    // First cancel any ongoing generation
    if (isGenerating) {
      cancelGeneration();
    }
    // Reset UI states
    setIsOpen(false);
    setMessage('');
    setSelectedSession({});
    setFileUploadError(false);
    setIsGenerating(false);
    setUploadedFiles([]);
    setThreadId(''); // Clear thread ID to trigger new thread creation on next interaction
    setMessages([]);
  }

  return (
    <div className="flex gap-3 items-center">
      {isShowHistory &&
        <ArrowLeft size={20} className="cursor-pointer" onClick={() => setIsShowHistory(false)} />
      }
      <div className="flex items-center gap-2">
        <span className="mr-2">
          {isShowHistory ? 'History' : 'Ask Zania'}
        </span>
        {!isShowHistory && (
          <div className="flex justify-center items-center px-2 gap-1 w-[42px] h-5 bg-[#FAFAFA] border-[0.5px] border-[#E4E4E7] rounded-[4px]">
            <span 
              className="w-[26px] h-5 font-medium text-[10px] leading-5 uppercase"
              style={{
                fontFamily: 'Inter',
                background: 'linear-gradient(180deg, #FF6496 0%, #812DD6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              BETA
            </span>
          </div>
        )}
      </div>

      {
        !isShowHistory && (
          <>
            <ZTooltip content={`New Chat`} showArrow={true} delay={0} >
              <Button isIconOnly
                disabled={!isOpen}
                size="sm"
                variant="bordered"
                onClick={() => handleNewChat()}
                className={`${btnClassName} ${!isOpen ? 'pointer-events-none border-blue-300 text-blue-300' : ''}`}
              >
                <SquarePen size={16} strokeWidth={1} />
              </Button>
            </ZTooltip>
            <ZTooltip content="History" placement="right" showArrow={true} delay={0} >
              <Button isIconOnly
                disabled={false}
                onClick={() => setIsShowHistory(true)}
                size="sm"
                variant="bordered"
                className={`${btnClassName}`}
              >
                <Clock7 size={16} strokeWidth={1} />
              </Button>
            </ZTooltip>
          </>)
      }

    </div>
  )
}